/* eslint-disable max-classes-per-file */
import {
  DirectionalLight3JS,
  EnvironmentSettings3JS,
  EnvMapSettings3JS,
  HemisphereLight3JS,
  LightsSettings3JS,
} from '@ess/jg-rule-executor/dist/src/domain/environment-settings-3js';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_environmentSettingsEditView,
  // eslint-disable-next-line @stylistic/max-len
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_environmentSettingsEditView_envMapSettings,
  // eslint-disable-next-line @stylistic/max-len
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_environmentSettingsEditView_lightsSettings,
} from '@src/app/generated/GetAllRetailers';
import {
  EnvironmentSettings3JSInput,
  EnvMapSettings3JSInput,
  LightsSettings3JSInput,
  LightsSettings3JSTypes,
} from '@src/app/generated/globalTypes';
import { PortalVector3 } from '@src/app/model/portalVector3';

export class PortalEnvironmentSettings3JS extends EnvironmentSettings3JS {
  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_environmentSettingsEditView
  ): PortalEnvironmentSettings3JS {
    return new PortalEnvironmentSettings3JS(
      gql.envMapSettings ? PortalEnvMapSettings3JS.fromGql(gql.envMapSettings) : undefined,
      gql.lightsSettings?.map(PortalLightsSettings3JS.fromGql),
      gql.shadowFloorOpacity
    );
  }

  static toGqlInput(input: EnvironmentSettings3JS): EnvironmentSettings3JSInput {
    return input
      ? {
        envMapSettings: PortalEnvMapSettings3JS.toGqlInput(input.envMapSettings),
        lightsSettings: input.lightsSettings?.map(PortalLightsSettings3JS.toGqlInput),
        shadowFloorOpacity: input.shadowFloorOpacity,
      }
      : undefined;
  }
}

export class PortalEnvMapSettings3JS extends EnvMapSettings3JS {
  static fromGql(
    // eslint-disable-next-line @stylistic/max-len
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_environmentSettingsEditView_envMapSettings
  ): PortalEnvMapSettings3JS {
    return new PortalEnvMapSettings3JS(gql.url, gql.height, gql.radius);
  }

  static toGqlInput(input: EnvMapSettings3JS): EnvMapSettings3JSInput {
    return input
      ? {
        url: input.url,
        height: input.height,
        radius: input.radius,
      }
      : undefined;
  }
}

export class PortalLightsSettings3JS extends LightsSettings3JS {
  static fromGql(
    // eslint-disable-next-line @stylistic/max-len
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_environmentSettingsEditView_lightsSettings
  ): LightsSettings3JS {
    switch (gql.__typename) {
      case 'DirectionalLight3JS':
        delete gql.shadowSettings.__typename;
        return new DirectionalLight3JS(
          PortalVector3.fromGql(gql.position),
          gql.color,
          gql.intensity,
          gql.shadowSettings,
          gql.target ? PortalVector3.fromGql(gql.target) : undefined
        );
      case 'HemisphereLight3JS':
        return new HemisphereLight3JS(
          PortalVector3.fromGql(gql.position),
          gql.skyColor,
          gql.groundColor,
          gql.intensity,
        );
    }
  }

  static toGqlInput(lightsSettings: LightsSettings3JS): LightsSettings3JSInput {
    if (lightsSettings instanceof DirectionalLight3JS) {
      return {
        type: LightsSettings3JSTypes.DirectionalLight3JS,
        directionallight3js: {
          ...lightsSettings,
          shadowSettings: {
            ...lightsSettings.shadowSettings,
          },
          position: PortalVector3.fromThree(lightsSettings.position).toGqlInput(),
          target: PortalVector3.fromThree(lightsSettings.target).toGqlInput(),
        },
      };
    } else if (lightsSettings instanceof HemisphereLight3JS) {
      return {
        type: LightsSettings3JSTypes.HemisphereLight3JS,
        hemispherelight3js: {
          ...lightsSettings,
          position: PortalVector3.fromThree(lightsSettings.position).toGqlInput(),
        },
      };
    } else {
      throw new Error(`Unknown lights settings type: ${lightsSettings.constructor.name}`);
    }
  }
}
